<template>
  <svg
     :width="width" 
    :height="height"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_31713_27316)">
      <path
        d="M12.6047 12.7617L9.87862 12.9723C9.12005 13.031 8.44445 13.4285 8.02494 14.0631L4.88097 18.8182C4.56281 19.2994 4.51223 19.9016 4.74558 20.4291C4.97899 20.9567 5.45867 21.3243 6.02869 21.4126L8.52478 21.7992C9.10868 18.7005 10.5065 15.6095 12.6047 12.7617Z"
        fill="currentColor"
      />
      <path
        d="M18.5322 31.8065L18.9189 34.3026C19.0072 34.8726 19.3748 35.3523 19.9023 35.5857C20.1218 35.6828 20.3541 35.7307 20.5852 35.7307C20.9099 35.7307 21.2323 35.6361 21.5133 35.4503L26.2685 32.3064C26.9031 31.8868 27.3007 31.2111 27.3592 30.4527L27.5698 27.7266C24.722 29.8249 21.631 31.2227 18.5322 31.8065Z"
        fill="currentColor"
      />
      <path
        d="M17.5931 30.0725C17.6797 30.0725 17.7669 30.0654 17.8538 30.0509C19.1521 29.8338 20.4033 29.4682 21.597 28.9895L11.3379 18.7305C10.8593 19.924 10.4936 21.1753 10.2765 22.4736C10.191 22.9853 10.3626 23.5067 10.7295 23.8736L16.4538 29.598C16.7584 29.9025 17.1695 30.0725 17.5931 30.0725Z"
        fill="currentColor"
      />
      <path
        d="M33.5577 18.2166C36.0682 13.3631 36.1612 8.23411 36.03 5.82867C35.9851 5.00447 35.328 4.34736 34.5037 4.30244C34.112 4.28105 33.6478 4.26562 33.1246 4.26562C30.4349 4.26562 26.1789 4.67303 22.1157 6.77468C18.8866 8.44491 14.6524 12.1226 12.1543 16.9557C12.1838 16.9788 12.2126 17.0032 12.2398 17.0304L23.3021 28.0927C23.3293 28.1199 23.3537 28.1486 23.3767 28.1781C28.2098 25.6799 31.8875 21.4457 33.5577 18.2166ZM22.8961 10.9178C24.6932 9.12069 27.6174 9.12051 29.4146 10.9178C30.2852 11.7883 30.7646 12.9459 30.7646 14.177C30.7646 15.4082 30.2852 16.5658 29.4146 17.4363C28.5161 18.3347 27.3356 18.7841 26.1554 18.7842C24.9749 18.7842 23.7948 18.335 22.8961 17.4363C22.0255 16.5658 21.546 15.4082 21.546 14.177C21.546 12.9459 22.0255 11.7883 22.8961 10.9178Z"
        fill="currentColor"
      />
      <path
        d="M24.2006 16.13C25.2789 17.2083 27.0335 17.2083 28.1118 16.13C28.6341 15.6076 28.9218 14.9131 28.9218 14.1744C28.9218 13.4357 28.6341 12.7412 28.1118 12.2189C27.5727 11.6797 26.8645 11.4102 26.1562 11.4102C25.448 11.4102 24.7398 11.6797 24.2007 12.2189C23.6784 12.7412 23.3906 13.4357 23.3906 14.1744C23.3906 14.9131 23.6783 15.6077 24.2006 16.13Z"
        fill="currentColor"
      />
      <path
        d="M5.54202 30.1895C5.77795 30.1895 6.01389 30.0995 6.19384 29.9194L9.20361 26.9097C9.56363 26.5496 9.56363 25.966 9.20361 25.606C8.84365 25.2459 8.25993 25.2459 7.89991 25.606L4.89013 28.6157C4.53011 28.9757 4.53011 29.5594 4.89013 29.9194C5.07014 30.0994 5.30608 30.1895 5.54202 30.1895Z"
        fill="currentColor"
      />
      <path
        d="M11.9618 28.3716C11.6019 28.0116 11.0182 28.0116 10.6581 28.3716L4.87158 34.1581C4.51156 34.5182 4.51156 35.1018 4.87158 35.4618C5.05159 35.6419 5.28752 35.7318 5.52346 35.7318C5.7594 35.7318 5.99533 35.6419 6.17528 35.4618L11.9618 29.6753C12.3219 29.3153 12.3219 28.7316 11.9618 28.3716Z"
        fill="currentColor"
      />
      <path
        d="M13.4155 31.1294L10.4058 34.1392C10.0457 34.4992 10.0457 35.0828 10.4058 35.4429C10.5858 35.6229 10.8217 35.7129 11.0576 35.7129C11.2935 35.7129 11.5295 35.6229 11.7094 35.4429L14.7192 32.4331C15.0792 32.0731 15.0792 31.4894 14.7192 31.1294C14.3592 30.7694 13.7755 30.7694 13.4155 31.1294Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_31713_27316">
        <rect
          width="31.4664"
          height="31.4664"
          fill="white"
          transform="translate(4.60059 4.26562)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
    name: 'RocketIcon',
    props: {
        width: {
            type: String,
            default: '40' // Default width
        },
        height: {
            type: String,
            default: '40' // Default height
        }
    }
}
</script>